module.exports = __webpack_public_path__ + "static/media/cloud-upload.95c8af06.svg";